// 定义所有 API 路径
const API_URLS = {
    RESOURCE_LOGIN:'/ckbop/front/account/login',
    RESOURCE_LOG:'/ckbop/front/account/Log',
    RESOURCE_UDERTOKEN:'/ckbop/front/account/check-ip',//登录认证接口
    RESOURCE_UDERINFO:'/ckbop/front/account/user-info',//用户信息
    RESOURCE_CHECKOAUTH:'/ckbop/front/account/check-oauth',//知识库页面嵌入前的校验
    RESOURCE_NAVI: "/ckbop/front/resource/selectContentNavi", // 资源导航数据
    RESOURCE_CONTENT:'/ckbop/front/resource/selectKnowledgeBaseList',  //知识库分类下列表
    RESOURCE_TUIJIANKNOW:'/ckbop/front/resource/selectUpKnowledgeBaseList',//推荐知识库
    RESOURCE_INSERUSERCART:'/ckbop/front/resource/insertUserCart',//添加购物清单
    RESOURCE_CARTBYUSERID:'/ckbop/front/resource/selectUserCartByUserid',//获取购物清单
    RESOURCE_DELETEUSERID:'/ckbop/front/resource/deleteUserCartById',//删除购物清单
    RESOURCE_UPDATEUSERID:'/ckbop/front/resource/updateUserCart',//修改购物清单
    RESOURCE_KNOWINFO:'/ckbop/front/resource/selectKnowledgeBaseInfo',//数据库详情
    RESOURCE_ORDERLIST:'/ckbop/front/resource/insertOrderList',//数据库详情
    RESOURCE_ORDERbyuserLIST:'/ckbop/front/resource/selectBuyKnowledgeList',//获取用户订单列表
    RESOURCE_KNOWLEDGEAREALIST:'/ckbop/front/resource/selectKnowledgeAreaList',//首页省份接口
    RESOURCE_USERCARLIST:'/ckbop/front/resource/insertUserCartList',//批量加入接口
    // RESOURCE_ORDERBYLIST:'/ckbop/front/resource//selectOrderByUserid',//订单支付页面接口  知识库列表
    RESOURCE_ORDERBYLIST:'/ckbop/front/resource/selectMainOrderByUserid',//订单支付页面接口  知识库列表
    RESOURCE_ORDERDELETELIST:'/ckbop/front/resource/deleteUserCartByIds',//清空订单页面接口
    RESOURCE_PROVINCEKONWLEDGELIST:'/ckbop/front/resource/selectProvinceKnowledgeBaseList',//获取地方特色的知识库的接口：
    RESOURCE_BUSINESSKNOWLEDGELIST:'/ckbop/front/resource/selectBusinessKnowledgeBaseList',//获取应用领域对应的知识库的接口
    RESOURCE_KNOWLEDEGEELIST:'/ckbop/front/resource/selectKnowledgeBangList',//知识库榜单
    RESOURCE_PROVINCE:'/ckbop/front/resource/getprovince',//地方省份特色
    RESOURCE_KNOWLEDGE:'/ckbop/front/resource/selectCompetitiveKnowledgeBaseList',//精品数据库
    RESOURCE_GETUNITUSER:'/ckbop/front/resource/getUnitUser',//精品数据库
    RESOURCE_CHECKUSER:'/ckbop/front/account/check-user',//登录过期验证
    RESOURCE_NEWKNOWLEDELIST:'/ckbop/front/resource/selectNewKnowledgeBaseList',//最新上架知识库接口
    RESOURCE_BUYKNOWLEDELIST:'/ckbop/front/resource/selectBuyKnowledgeBaseList',//最新上架知识库接口
    RESOURCE_LIBRARYKNOWLEDGE:'/ckbop/front/resource/selectLibraryKnowledgeBaseList',//获取数字图书馆
    RESOURCE_YWDT:'/ckbop/front/resource/selectNotice',//获取数字图书馆
    RESOURCE_HZHB:'/ckbop/front/resource/selectPartner',//获取数字图书馆
    selectIndexKnowledgeUp:'/ckbop/front/resource/selectIndexKnowledgeUp',//获取数字图书馆
    selectIndexKnowledgeDown:'/ckbop/front/resource/selectIndexKnowledgeDown',//获取数字图书馆
    selectIndexBannerList:'/ckbop/front/resource/selectIndexBannerList',//获取数字图书馆
                         
    // 其他 API 路径...
  };
  
  export default API_URLS;